import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Store, ArrowRight } from 'lucide-react'
import { useInView } from './useInView'
import { useT } from '../i18n/LanguageContext'

/**
 * Drugi produkt w obrębie „Produktów" — teaser Plugin Commerce prowadzący na
 * podstronę. Osobna sekcja (nie doklejka pod Spotto), żeby dostała ten sam
 * standardowy rytm pionowy co reszta landingu: `pt-8 pb-24 min-h-[88vh]`
 * z centrowaniem w pionie. Spotto zostaje flagowcem w sekcji wyżej.
 */
export default function ProductPluginCommerce() {
  const t = useT()
  const { ref, isInView } = useInView()

  return (
    <section className="relative pt-8 pb-24 min-h-[88vh] flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0 bg-radial-top" />

      <div ref={ref} className="relative z-10 w-full max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <Link
            to="/plugin-commerce"
            className="group block rounded-2xl border border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.05] hover:border-white/[0.14] transition-all p-8 sm:p-12"
          >
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <div className="w-14 h-14 rounded-xl border border-commerce-500/30 bg-commerce-500/10 flex items-center justify-center shrink-0">
                <Store size={26} className="text-commerce-400" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-mono text-commerce-400 text-xs tracking-[0.2em] uppercase mb-2">
                  {t.product.plugin.eyebrow}
                </p>
                <h3 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight">
                  {t.product.plugin.name}
                </h3>
                <p className="mt-1 text-brand-400 text-sm sm:text-base">
                  {t.product.plugin.tagline}
                </p>
                <p className="mt-3 text-zinc-400 leading-relaxed max-w-2xl">
                  {t.product.plugin.description}
                </p>
              </div>
              <span className="inline-flex items-center gap-2 self-start sm:self-center px-5 py-3 rounded-xl bg-white/[0.06] group-hover:bg-white/[0.1] border border-white/[0.08] text-sm font-semibold text-white transition-all shrink-0">
                {t.product.plugin.cta}
                <ArrowRight
                  size={16}
                  className="group-hover:translate-x-0.5 transition-transform"
                />
              </span>
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  )
}
